const Form046EN = {
    stepName: {
        statement: "Statement",
        information: "Information",
        confirmation: "Confirmation",
    },
    title: {
        title1: "Tenancy Agreement",
        title2: "Documentary Evidence",
        title3: "a) Tenancy Agreement",
        title4: "b) Others (e.g.: Documents confirming the permission to sublet or to receive rent)",
        title5: "Personal Information Collection Statement",
        information: "Information",
        informationText1: `I wish to inform you that the Tenancy Agreement of our kindergarten-cum-child care centre has been  renewed  for  a  term  of `,
        informationText2: ` from `,
        informationText3: ` to `,
        informationText4: ` with rent payable at $ `,
        informationText5: ` per month throughout the term, and apply for continued reimbursement for rent expense when the new Tenancy Agreement becomes effective.`,
    },
    content: {
        content1a: `I wish to inform you that the Tenancy Agreement of our kindergarten-cum-child care centre has been renewed`,
        content1b: `for a term of`,
        content2: `with rent payable at`,
        content3: `throughout the term, and apply for continued reimbursement for rent expense when the new Tenancy Agreement becomes effective.`,
    },
    note: {
        note1: {
            title: `1.	The personal data provided by you in this form will be used by the EDB for one or more of the following purposes:`,
            subtitle: "Purpose of Collection",
            content1:
                "(a)	Activities relating to the processing, authentication and counter-checking of Renewal of Tenancy Agreement for Non-Profit-Making Kindergarten-cum-Child Care Centres;",
            content2:
                "(b)	Activities relating to matching of the personal data with the database of other relevant Government bureaux / departments in connection with the processing, authentication and counter-checking of the application mentioned in (a) above;",
            content3:
                "(c)	Activities relating to matching of the personal data within the database of EDB for purposes of verifying / updating records of the EDB;",
            content4:
                "(d)	Activities relating to training and development including invitation of participation in programmes / activities, applications for reimbursement of course fees, assessment of nominations, awards and scholarship, and monitoring of attainment progress;",
            content5:
                "(e)	Activities relating to the processing and vetting of applications for, and disbursement of, funding / grants / subsidies, and conducting of audits;",
            content6:
                "(f)	Activities relating to compilation of statistics, research and Government publications; and",
            content7:
                "(g)	Activities relating to the administration and enforcement of rules and regulations including the Education Ordinance (Cap. 279), its subsidiary legislation (such as the Education Regulations and the Grant/Subsidized Schools Provident Fund Rules), the Codes of Aid; and the Child Care Services Ordinance (Cap.243) and its subsidiary legislation (i.e., the Child Care Services Regulations (Cap 243 A) )",
        },
        note2: {
            title: `2.	The provision of personal data required by this form and during the processing of this form is obligatory.  In the event that you do not provide those personal data, we may not be able to handle or further process the application.`,
        },
        note3: {
            title: `3.	The personal data you provide will be made available to persons working in EDB.  Apart from this, they may be transferred or disclosed to the parties or in the circumstances listed below:-`,
            subtitle: "Classes of Transferees",
            content1:
                "(a)	other Government bureau and departments for the purposes mentioned in paragraph 1 above;",
            content2:
                "(b)	the school in which the form relates for the purposes mentioned in paragraph 1 above;",
            content3:
                "(c)	where you have given your prescribed consent to such disclosure; and",
            content4:
                "(d)	where such disclosure is authorised or required under the law or court order applicable to Hong Kong.",
        },
        note4: {
            title: `4.	You have the right to request access to and correction of your personal data held by EDB.  Request for access or correction of personal data should be made in writing to intake officer at Room 602, 6/F, 14 Taikoo Wan Road, Taikoo Shing, Hong Kong or email to <a href='mailto: jokc@edb.gov.hk'>jokc@edb.gov.hk</a>.`,
            subtitle: "Access to Personal Data",
        },
    },
    label: {
        termsConditions:
            "I undertake to refund to the Government any amount overpaid.",
        reimbursementCheck:
            "If the application for reimbursement of rent for the school premises is approved, I agree to include in the school accounts all income generated through the use of my school premises, including fee-collecting activities organized by my school or outside bodies in the non-school hours. After being audited, the school accounts will be submitted to EDB.",
        termFrom: "Term from",
        termTo: "Term to",
        years: "a term of",
        year: "year",
        month: "month",
        day: "day",
        payableMonth: "Rent payable at $___ per month",
        payableMonth1: "Rent payable at $",
        payableMonth2: "  per month",
        documentaryEvidence:
            "The following copies of documentary evidence are enclosed to support my application: ",
        attachment: "Tenancy Agreement",
        otherAttachment:
            "Others(e.g.: Documents confirming the permission to sublet or to receive rent)",
        statement:
            "I have read, understood and agreed to the above terms and conditions.",
        iAmSmartText:
            "I understand applicant and the approving authority of the school need to have an “iAM Smart+” account to process the application.",
        supervisorName: "Name of Supervisor",
        kindergartenName: "Name of Kindergarten",
        kindergartenAddress: "Address of Kindergarten",
        specify: "Please specify",
        autoGenerate: "auto-generated",
        naOption: "N/A",
    },
    errorMsg: {
        least30Days: "Please enter a complete month",
    },
    importantNote:
        "Applicant without an “iAM Smart+” account is required to return the completed form to Joint Office for Kindergartens and Child Care Centres for processing (Address: Room 602, 6/F, 14 Taikoo Wan Road, Taikoo Shing, Hong Kong).　Please ensure that sufficient postage is paid to avoid unsuccessful delivery. Any underpaid mail items will be disposed of by the Hongkong Post.",
};
export default Form046EN;
